const LOGIN_MESSAGES = {
  INVALID_CREDENTIALS: 'Email & Password are required.',
  LOGIN_SUCCESS: 'Logged in successfully',
  LOGIN_FAILURE: "Email and Password don't match",
  EMAIL_TOO_SHORT: 'Email address is too short',
  EMAIL_TOO_LONG: 'Email address is too long',
  EMAIL_INVALID: 'Email address is invalid',
  EMAIL_REQUIRED: 'Email address is required',
  ORGANIZATION_ID_REQUIRED: 'Organisation is required',
  PASS_TOO_SHORT: 'Password is too short - should be 6 chars minimum.',
  PASS_TOO_LONG: 'Too Long!',
  PASS_REQUIRED: 'Password is required',
  EMAIL_LABEL: 'Email Address or Username*',
  PASS_LABEL: 'Password',
  ORGANIZATION_LABEL: 'Select an Organisation',
  EMAIL_PLACEHOLDER: 'Email Address or Username',
  PASS_PLACEHOLDER: 'Password',
  SUBMIT_BUTTON_LABEL_SUBMITTING: 'Sign in...',
  SUBMIT_BUTTON_LABEL: 'Sign in',
  FORGOT_PASS_LINK_LABEL: 'Forgot Password?',
  SSO_LINK_LABEL: 'Sign-in using Single Sign-on',
  REGISTER_LINK_LABEL: 'Create new account',
  USER_NOT_EXIST: 'User does not exist !'
};
export default LOGIN_MESSAGES;